import { Component, ChangeDetectionStrategy , inject} from '@angular/core';
import { Router } from '@angular/router';

//Componentes
import { ModificarCompaniaComponent } from '@/app/components/catalogos/Compania/modificar-compania/modificar-compania.component';
import { InsertarCompaniaComponent } from '@/app/components/catalogos/Compania/insertar-compania/insertar-compania.component';

//Servicios
import { CompaniaService } from '@/app/services/compania.service';

//Librerías externas
import {MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

//Modelos
import { Compania } from '@/app/models/Compania';

@Component({
    selector: 'app-obtener-compania',
    templateUrl: './obtener-compania.component.html',
    styleUrls: ['./obtener-compania.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ObtenerCompaniaComponent {
  private spinner = inject(NgxSpinnerService);

  //Lista de usuarios
  listaCompanias: Compania[] = [];


  constructor(
    private companiaService: CompaniaService,
    private toastr: ToastrService, 
    private router: Router,
    private dialog: MatDialog,

  ){
    this.obtenerCompania();
  }

  obtenerCompania(){
    this.spinner.show();

    this.companiaService.obtenerCompania().subscribe({
      next: (data: any)=>{
        this.listaCompanias = data.Companias;
        this.spinner.hide();
      },
      error: (err) =>{
        this.spinner.hide();
        
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
          this.toastr.error(ClassInfo.Error, 'Error');
          }
        }
        console.log(err);
      }
    });
  }


  abrirModalInsertarCompania(){
    const dialogRef = this.dialog.open(InsertarCompaniaComponent, {
      width: '540px',
      height: '330px',
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) this.obtenerCompania();
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }


  abrirModalEditarCompania(compania: Compania){
    const dialogRef = this.dialog.open(ModificarCompaniaComponent, {
      width: '540px',
      height: '330px',
      panelClass: 'custom-dialog-container',
      data: compania,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) this.obtenerCompania();
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }
}
